module.exports = __webpack_public_path__ + "media/standalone/contributor-318ddaf6.svg";